const message = {
  englishTextOne: "专业期权交易者的工具箱",
  englishTextTwo: "首页",
  englishTextThree: "大宗交易",
  englishTextFour: "新手教程",
  englishTextFive: "联系我们",
  englishTextSix: "推特",
  englishTextSeven: "电报 (中文)",
  englishTextEight: "电报 (英文)",
  englishTextNine: "关于我们",
  englishTextTen: "大师计划",
  englishTextEleven: "连接",
  englishTextTwelve: "交易网站",
  englishTextThirteen: "一键对冲",
  englishTextFourteen: "一键追单",
  englishTextFifteen: "订单排序",
  AutoLendingTool: "自动借贷工具",
  englishTextSixteen: "自定义列",
  englishTextSeventeen: "头寸可视化",
  englishTextEighteen: "期权结构、成交量、持仓悬浮窗口",
  englishTextNineteen: "行情回放",
  englishTextTwenty: "子账号",
  englishTextTwentyOne: "期权简选",
  englishTextTwentyTwo: "头寸可视化",
  englishTextTwentyFour: "数据实验室",
  englishTextTwentyFive: "高级自动 DDH，限价单",
  englishTextTwentySix: "自动合成交割",
  englishTextTwentySeven: "合成敲入期权",
  englishTextTwentyEight: "期货互换",
  dataLabDesc06: "最大痛点",
  englishTextTwentyNine: "行情回放",
  playBackDesc01: "回放最近的期权市场活动",
  playBackDesc02: "回放IV是如何逐步变化的",
  englishTextThirty: "高阶交易工具",
  englishTextThirty02: "高阶交易工具",
  advanceToolsDesc01: "动态对冲",
  advancedToolsDesc02: "挂单助手",
  advancedToolsDesc03: "期货互换",
  advancedToolsDesc04: "合成交割",
  englishTextThirtyOne: "服务条款",
  englishTextThirtyTwo: "Deribit",
  englishTextThirtyThree: "BIT",
  trade: '交易',
  baseTrade: '基础交易',
  socialTrading: '实盘系统',
  joinTg: '加入我们的期权交易社区',
  relatedProducts: '相关产品',
  whyOptions: '为什么选择加密期权？',
  whyOptionsDesc01: '超级高杠杆率高达 2000 倍，没有强制平仓的风险（仅限标准保证金买入期权）',
  whyOptionsDesc02: '在保留上涨潜力的同时有效对冲投资组合；',
  whyOptionsDesc03: '即使在熊市也能获得最佳收益；',
  whyOptionsDesc04: '波动率的新交易维度。跨式期权、宽跨式期权、蝶式期权和带有主动 Delta 对冲的期权交易；',
  feature: '最新热门功能',
  startDate: '项目开始日期',
  runningTime: '至今安全运行',
  days: '天',
  backed: '最好的支持',
  subtitle: '同步四个主要交易所账户，让您的投资更加方便',
  officialWebsite: '前往官网',
  lengTools: '借贷工具',
  lengToolsDesc01: '多种加密货币选择',
  lengToolsDesc02: '灵活的借贷期限',
  lengToolsDesc03: '自动匹配借贷交易',
  lengToolsDesc04: '高安全性和透明度',
  lengToolsDesc05: '良好的流动性和市场深度',
  userProtocolTitle: 'Greeks.live 服务条款',
  termsOfServiceAutoDDHContentL: '<p>为了使用网页交易、高阶交易工具、灵动策略和实盘展示功能，您同意并授权我们的服务器读取您的仓位信息并进行数据处理和交易执行。</p><p>本应用提供给您一个管理头寸组合的工具。您应评估后独立承担风险使用。您了解并同意本应用有高度的财务风险，您有足够的经验和知识了解本应用的风险。</p><p>我们会尽力提供一款运行顺利的应用。在我们认为需要时，会尽快修复错误和缺陷并对应用进行升级。我们不对任何错误或缺陷造成的后果承担责任。使用本应用带来的任何风险、损失或伤害都由您独自承担。</p><p>在数字货币交易所宕机或维护时，我们无法向交易所传递交易信号。这个风险由您独自承担。</p>',
  termsOfServiceAPIKeyContentL: '<p>当您使用API密钥时，请确保其被妥善存放和传输。暴露您的密钥会导致您的账户被盗。以下为推荐的最优做法：</p><li>我们推荐您使用IP白名单，这样可以降低泄露密钥的影响。</li><li>删除不需要的API密钥，从而降低被攻击的敞口。</li><li>定期重置您的API密钥。</li><p>请注意：Greeks.live及其应用不存放您任何API密钥信息。您将是安全使用您API密钥的单一责任人。</p>',
  advanceToolsTips: '提供了更大的灵活性和风险管理能力。',
  learnMoreDatalab: '了解更多关于Greeks.live数据实验室',
  learnMorePlayback: '了解更多关于Greeks.live行情回放',
  downloadApp: '下载APP',
  tips: '提示',
  copySuccess: '复制下载链接成功',
  download: '下载',
  openInBrowser: '请使用浏览器打开',
  oldVer2: '旧版本',
  termsContent: {
      introduction: '简介',
      termsIntroContent: '<p>感谢您选择 Greeks.live 服务。本综合协议包含我们的服务条款和隐私政策。请仔细阅读本文件，因为它说明了我们的服务、您的权利和责任，以及我们如何保护您的信息。</p>',
      services: '服务',
      webTradingServices: 'Web 交易及高阶交易工具',
      webTradingServicesContent:  `
        <ul class="ol">
        <li>我们提供 web 交易、高阶交易工具、智能下单和实盘分享等功能</li>
        <li>我们的服务器将处理您的持仓信息以便于交易</li>
        <li>我们会尽最大努力维护应用程序，但对任何程序错误或缺陷不承担责任</li>
        <li>使用应用程序或加密货币交易所停机带来的任何风险均由您自行承担</li>
        </ul>`,
      rfqServices: 'RFQ 交易服务',
      rfqServicesContent: `
        <ul class="ol">
          <li>RFQ 交易是指单笔交易价值大于或等于 25 BTC 或 250 ETH 的加密货币交易</li>
          <li>用户可以在平台上报价或查询 RFQ 交易订单</li>
          <li>平台将根据用户订单的价格和数量信息寻找合适的交易伙伴并协助撮合订单，但不保证订单一定能执行</li>
        </ul>
      `,
      security: '安全和 API 密钥',
      securityContent: `
        <p>当您使用 API 密钥时，请确保在存储和传输过程中都保持安全。公开暴露您的凭据可能导致账户被盗用，从而可能产生意外的账户费用。为了帮助确保您的 API 密钥安全，请遵循以下最佳实践：</p>
        <ul class="ol">
          <li>为了帮助确保您的 API 密钥安全，请遵循以下最佳实践：</li>
          <li>我们建议设置 API 密钥 IP 白名单</li>
          <li>删除不需要的 API 密钥</li>
          <li>定期重新生成您的 API 密钥</li>
        </ul>
        <p>Greeks.live 及其应用程序不会存储您的任何 API 密钥信息。在使用过程中，您需要自行负责确保 API 密钥的安全。</p>
      `,
      dataCollection: '信息收集与使用',
      dataCollectionContent: `
        <p>我们收集和处理：</p>
        <ul class="ol">
          <li>账户注册信息</li>
          <li>设备和技术信息</li>
          <li>交易和持仓数据</li>
          <li>操作日志和浏览器数据</li>
        </ul>
      `,
      howToUse: '我们如何使用您的信息',
      howToUseContent: `
        <ul class="ol">
          <li>提供交易和账户服务</li>
          <li>改善用户体验</li>
          <li>履行法律义务</li>
          <li>发送服务更新和营销邮件</li>
        </ul>
      `,
      dataSecurity: '数据保护和安全',
      dataSecurityContent: `
         <ul class="ol">
          <li>我们实施合理的安全措施</li>
          <li>您的个人信息受到保护，防止未经授权的访问</li>
          <li>我们使用 cookies 优化服务</li>
          <li>您可以管理 cookie 偏好设置</li>
        </ul>
      `,
      fees: '服务费用',
      feesContent: `
        <p>关于 RFQ 交易服务：</p>
        <ul class="ol">
          <li>平台将把订单和执行传输至 Deribit 和其他交易所执行</li>
          <li>Greeks.live 仅提供订单撮合协助</li>
          <li>交易费用将在相应交易所的公告中指定</li>
          <li>Greeks.live 不收取任何中间费用</li>
        </ul>
      `,
      risks: '风险提示',
      risksContent: `
        <ul class="ol">
          <li>加密货币市场具有高风险，您应充分了解风险并对使用平台进行交易可能带来的潜在风险和损失承担责任</li>
          <li>Greeks.live 不对用户因使用平台服务可能遭受的任何直接或间接损失承担责任</li>
          <li>平台无法保证订单一定能够执行</li>
        </ul>
      `,
      updates: '更新和修改',
      updatesContent: `
        <ul class="ol">
          <li>我们保留更新本协议的权利</li>
          <li>继续使用我们的服务即表示您接受修改内容</li>
          <li>平台拥有本协议的最终解释权</li>
        </ul>
      `,
      contact: '联系方式',
      contactContent: `
          <p>如有问题或需要支持：<a href="mailto:support@greeks.live" target="_blank" style="color: #606266; text-decoration: none;">support@greeks.live</a></p>
      `
  },
  disclaimer: '免责声明',
}


const zh = {
  message: message,
}

export default zh
